import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router';
import Layout from './components/Layout.vue';
import { i18n } from './i18n/index'; //国际化

Vue.use(ElementUI);

import './assets/css/main.css';

new Vue({
  el: '#app',
  router,
  i18n, //使用国际化
  render: h => h(Layout)
});
